import { errorNotifier } from "../../../components/NotificationHandler";
import http, { AUTH_ROUTES } from "../../../services/api";

export const loginUser = async (payload, setLoading) => {
  try {
    const {
      data: { data },
    } = await http.post(AUTH_ROUTES.LOGIN_USER, payload);
    const token = data?.token;
    setLoading(false);
    localStorage.setItem("WMS#221#", token);
    try {
      localStorage.setItem("WMS_USER", JSON.stringify(data));
    } catch (e) {
      // ignore storage errors
    }
    return data;
  } catch (e) {
    setLoading(false);
    errorNotifier(e.response?.data?.data);
    throw e;
  }
};
